module.exports = {"data":{"activities":{"cover":{"all":["SHE_01","PAC_16"]}}},"ts":0};